import { useState, useEffect } from 'react';

const useFetchEmployeeReviews = (employeeId) => {
  const [reviews, setReviews] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (!employeeId) {
      setLoading(false);
      return;
    }

    const fetchReviews = async () => {
      try {
        setLoading(true);
        const response = await fetch(
          `${process.env.REACT_APP_BACKEND_STAGING_URL}/api/reviews/employee/${employeeId}`,
          {
            method: 'GET',
            credentials: 'include',
            headers: {
              'Content-Type': 'application/json',
            },
          }
        );

        if (!response.ok) {
          throw new Error('Failed to fetch reviews');
        }

        const data = await response.json();
        if (data.success) {
          setReviews(data.data || []);
        } else {
          setReviews([]);
        }
        setError(null);
      } catch (err) {
        console.error('Error fetching employee reviews:', err);
        setError(err.message);
        setReviews([]);
      } finally {
        setLoading(false);
      }
    };

    fetchReviews();
  }, [employeeId]);

  return { reviews, loading, error };
};

export default useFetchEmployeeReviews;

